export default __webpack_public_path__ + "c3403b00ac6b0b26b38c18beae318d0a.png";